// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g6zFf","toggle":"styles_toggle__2ax1r","preview":"styles_preview__3IR25"};